(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDialogController', DinghyEventDialogController);

    DinghyEventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DinghyEvent', 'Profile', 'Dinghy'];

    function DinghyEventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DinghyEvent, Profile, Dinghy) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.dinghies = Dinghy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghyEvent.id !== null) {
                DinghyEvent.update(vm.dinghyEvent, onSaveSuccess, onSaveError);
            } else {
                DinghyEvent.save(vm.dinghyEvent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
